import Model from '../Model';
import DistributionSiteModel from './DistributionSiteModel';

export default class DistributionSitesModel extends Model {

	constructor(data) {
		super(data);
		this.sites = data.length ? _.sortBy(data.map(site => new DistributionSiteModel(site)),'name') : [];
	}

	build(dryRun) {
		return {
			dry_run: !!dryRun,
			distribution_rules: this.sites.map(site => site.build())
		};
	}
}



// WEBPACK FOOTER //
// ./modules/distribution/core/models/distribution/DistributionSitesModel.js